var React = require('react');
var PropTypes = React.PropTypes;
var ReactMotion =  require('./react-motion/react-motion');
var TransitionSpring = ReactMotion.TransitionSpring;
var TransitionMotion = ReactMotion.TransitionMotion;
var spring = ReactMotion.spring;

/**
 * One example of using react-motion (0.3.0) within react-router (v1.0.0-rc3).
 *
 * Usage is simple, and really only requires two things–both of which are
 * injected into your app via react-router–pathname and children:
 *
 *   <RouteTransition pathname={this.props.pathname}>
 *     {this.props.children}
 *   </RouteTransition>
 */
var RouteTransition = React.createClass({

  propTypes: {
    pathname: PropTypes.string.isRequired
  },

  getInitialState: function() {
    return {
      handlers: {}
    };
  },

  componentWillMount: function() {
    var handlers = {};

    handlers[this.props.pathname] = this.props.children;

    this.setState({ handlers: handlers });
  },

  componentWillReceiveProps: function(nextProps) {
    var handlers = this.state.handlers;
    var pathname = this.props.pathname;

    var  nextHandler = nextProps.children;
    var nextPathname = nextProps.pathname;

    if (nextPathname !== pathname) {
      handlers[nextPathname] = nextHandler;

      this.setState({ handlers: handlers });
    }
  },

  willEnter: function() {
    return { opacity: spring(0, [20, 0.6]) };
  },

  willLeave: function(key, value, endValue, currentValues, currentSpeed) {
    return { opacity: spring(0, [150, 0.2]) };
  },

  getStyles: function() {
    var ret = {};

    ret[this.props.pathname] = { handler: this.props.children,
                                 opacity: spring(1, [20, 20]) }
    return ret;
  },

  render: function() {
    return (
      <TransitionMotion
        styles={this.getStyles()}
        willEnter={this.willEnter}
        willLeave={this.willLeave} >
        { function(interpolated) {
          return (
          <div>
            { Object.keys(interpolated).map(function(key) {
                return <div key={key}
                            style={{ opacity: interpolated[key].opacity }} >
                            {this.state.handlers[key]}
                       </div>
              }.bind(this))
            }
          </div>)
          }.bind(this)
        }
      </TransitionMotion>
    );
  }
});

module.exports = RouteTransition;